import store from '@/state/store'
import guestMiddleware from './../middleware/guestMiddleware';

export default [

  //#region Standard Dashboard Routes.
  //#region Auth Routes.
  {
    path: '/',
    name: 'default',
    redirect: store.getters['auth/loggedIn'] ? '/statistics' : '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    beforeEnter: guestMiddleware
  },
  {
    path: '/account',
    name: 'account',
    meta: {
      middleware: ['authMiddleware'],
    },
    component: () => import('./views/account/account')
  },
  //#endregion
  
  //#region Errors Routes.
  {
    path: '*',
    redirect: '/404',
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  {
    path: '/500',
    name: '500',
    component: require('./views/utility/500').default,
  },
  //#endregion
  
  //#region Admin Routes.
  {
    path: '/statistics',
    name: 'statistics',
    meta: {
      middleware: ['authMiddleware'],
    },
    component: () => import('./views/statistics/index')
  },
  {
    path: '/admins',
    name: 'admins.index',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_admin|add_admin|edit_admin|delete_admin'],
    },
    component: () => import('./views/admins/index')
  },
  {
    path: '/admins/:id/edit',
    name: 'admins.edit',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:edit_admin'],
    },
    component: () => import('./views/admins/edit')
  },
  {
    path: '/admins/password/:id/reset',
    name: 'admins.password.reset',
    meta: {
      middleware: ['authMiddleware'],
    },
    component: () => import('./views/admins/reset_password')
  },
  {
    path: '/admins/log_activity',
    name: 'admins log_activity',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_logs'],
    },    component: () => import('./views/admins/log_activity')
  },
  //#endregion

  //#region Custom Dashboard Routes.
  //#region Post route
  {
    path: '/posts',
    name: 'posts.index',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_post|add_post|edit_post|delete_post'],
    },
    component: () => import('./views/posts/index')
  },
  {
    path: '/posts/:id/edit',
    name: 'posts.edit',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:edit_post'],
    },
    component: () => import('./views/posts/edit')
  },
  //#endregion

  //#region Blog route
  {
    path: '/offer',
    name: 'offer.index',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_blog|add_blog|edit_blog|delete_blog'],
    },
    component: () => import('./views/offer/index')
  },
  {
    path: '/offer/:id/edit',
    name: 'offer.edit',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:edit_blog'],
    },
    component: () => import('./views/offer/edit')
  },
  //#endregion
  
  //#region About route
  {
    path: '/about',
    name: 'about.edit',
    meta: { 
      middleware: ['authMiddleware', 'canMiddleware:edit_about'],
    },
    component: () => import('./views/about/edit')
  },
  //#endregion

  //#region Image route
  {
    path: '/images',
    name: 'images.index',
    meta: { 
      middleware: ['authMiddleware', 'canMiddleware:show_image|add_image|edit_image|delete_image'],
    },
    component: () => import('./views/images/index')
  },
  {
    path: '/images/:id/edit',
    name: 'images.edit',
    meta: { 
      middleware: ['authMiddleware', 'canMiddleware:edit_image'],
    },
    component: () => import('./views/images/edit')
  },
  //#endregion

  //#region Video route
  {
    path: '/videos',
    name: 'videos.index',
    meta: { 
      middleware: ['authMiddleware', 'canMiddleware:show_video|add_video|edit_video|delete_video'],
    },    component: () => import('./views/videos/index')
  },
  {
    path: '/videos/:id/edit',
    name: 'videos.edit',
    meta: { 
      middleware: ['authMiddleware', 'canMiddleware:edit_video'],
    },
    component: () => import('./views/videos/edit')
  },
  //#endregion

  //#region Quotation route
  {
    path: '/quotation',
    name: 'quotation.edit',
    meta: { 
      middleware: ['authMiddleware', 'canMiddleware:edit_quotation'],
    },
    component: () => import('./views/quotation/edit')
  },
  //#endregion

  //#region Attachment route
  {
    path: '/attachments',
    name: 'attachments.index',
    meta: { 
      middleware: ['authMiddleware', 'canMiddleware:show_attachment|add_attachment|edit_attachment|delete_attachment'],
    },
    component: () => import('./views/attachments/index')
  },
  {
    path: '/attachments/:id/edit',
    name: 'attachments.edit',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:edit_attachment'],
    },
    component: () => import('./views/attachments/edit')
  },
  //#endregion

  //#region Link route
  {
    path: '/links',
    name: 'links.index',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_link|add_link|edit_link|delete_link'],
    },
    component: () => import('./views/links/index')
  },
  {
    path: '/links/:id/edit',
    name: 'links.edit',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:edit_link'],
    },
    component: () => import('./views/links/edit')
  },
  //#endregion

  //#region SocialMedia route
  {
    path: '/social-media',
    name: 'social-media',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:edit_social_media'],
    },
    component: () => import('./views/social-media/edit')
  },
  //#endregion
  //#endregion

  //#endregion
]
